export function whenDefined<T, R>(
  value: T | undefined | null,
  builder: (v: T) => R,
): R | undefined {
  return value != null ? builder(value) : undefined;
}
